<template>
    <!--begin::Dashboard-->
    <div class="row">
        <div class="col-lg-3 aos-init aos-animate text-center d-none d-lg-block mx-auto resume-content" data-aos="fade-right fade-left" data-aos-delay="100" >
          <div class="card resume-content float-right">
            <div class="card-header"><div class="tarjeta-perfil"></div></div>
            <div class="card-body">
              <div class="card-text">
                <span>Nombre Empresa</span> <p class="text-truncate">{{client.nombreEmpresa}}</p>
              </div>
              <div class="card-text">
                <span>RUT empresa</span> <p>{{client.rutEmpresa}}-{{client.rutEmpresaDv}}</p>
              </div>
              <div class="card-text">
                <span>Correo Corporativo</span> <p class="text-truncate">{{client.email}}</p>
              </div>
             
            </div>
          </div>
        </div>
        <div v-if="order.numeroTransaccion==0 && order.enRegulacion==0" class="col-md-12 col-lg-9 aos-init aos-animate content d-flex flex-column mt-1 mb-5 mx-auto" data-aos="fade-up" data-aos-delay="100">
          <h3>Pago No realizado</h3>
          <div class="row card card-row d-flex flex-row ">
            <div class="row d-flex flex-row mb-0 justify-items-between  align-items-start">
              <div class="col-2 text-center p-0">
                <i class="fa fa-times-circle text-danger"></i>
              </div>
                      <div class="col-10">
                        <p>Hemos recibido su pago desde el banco.<br/>
                         Debido a problemas de comunicación no hemos podido validar de forma inmediata su pago y nos encontramos procesando la información.<br/>
                        Si en unos minutos no recibe un email con la confirmación de su pago, por favor pongase en contacto con nosotros.  
                        </p>
              </div>
            </div>
        </div>
        </div>
        <div v-if="order.enRegulacion==1"  class="col-md-12 col-lg-9 aos-init aos-animate content d-flex flex-column mt-1 mb-5 mx-auto" data-aos="fade-up" data-aos-delay="100">
          <h3>Pago en Proceso</h3>
          <div class="row card card-row d-flex flex-row ">
            <div class="row d-flex flex-row mb-0 justify-items-between  align-items-start">
              <div class="col-2 text-center p-0">
                <i class="fa fa-info-circle text-information"></i>
              </div>
                      <div class="col-10">
                        <p>Hemos recibido su pago correctamente<br/>
                        En estos momentos nos encontramos procesando y actualizando su información. En unos minutos recibirá un correo electrónico con el comprobante de pago.
                        <br/>
                        
                        </p>
              </div>
            </div>
        </div>
        </div>
       
        <template v-if="order.numeroTransaccion>0">
        <div class="col-md-12 col-lg-9 aos-init aos-animate content d-flex flex-column mt-1 mb-5 mx-auto" data-aos="fade-up" data-aos-delay="100">
          <h3>Pago realizado</h3>
          <h2>resumen de pago</h2>
          <div class="row card card-row d-flex flex-row ">
            <div class="row d-flex flex-row mb-0 justify-items-between  align-items-start">
              <div class="col-2 text-center p-0">
                <img src="/media/img/check.svg" alt="">
              </div>
                      <div class="col-10">
                        <p>Has realizado un pago en línea a través de {{order.codigoMedioPago}}.
                        Hemos enviado copia(s) del comprobante al correo <a href="#">{{client.email}}</a>.</p>
                        <div class="card card-row d-flex flex-row justify-content-between align-items-start row  mb-4 p-3">
                          <div class="form-group col-sm-12 col-lg-4 mb-1 mt-1 text-center">
                            <label for="inputLocale" class="justify-content-center text-center">comprobante Nº</label>  
                            <span id="inputLocale" class="justify-content-center text-center">{{order.numeroTransaccion}}</span>
                          </div>
                          <div class="form-group col-sm-12 col-lg-4 mb-1 mt-1 text-center">
                            <label for="inputMount" class="justify-content-center text-center">fecha de pago</label>  
                            <span id="inputMount" class="justify-content-center text-center">{{order.fechaCreacion|formatDate}}</span>
                          </div>
                          <div class="form-group col-sm-12 col-lg-4 mb-1 mt-1 text-center">
                            <label for="inputCredited" class="justify-content-center  text-center pb-0">pagado</label>  
                            <h4 id="inputCredited" class="justify-content-center  text-center mb-0">{{order.monto==0?order.montoOriginal:order.monto|currency}}</h4>
                          </div>
                        </div>

                        <!--inicio comprobante-->
                        <table border="0" cellpadding="0" cellspacing="0" class="nl-container" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: transparent; background-image: none; background-position: top left; background-size: auto; background-repeat: no-repeat;" width="100%">
<tbody>
<tr>
<td>
<table align="center" border="0" cellpadding="0" cellspacing="0" class="row row-1" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-size: auto;" width="100%">
<tbody>
<tr>
<td>
<table align="center" border="0" cellpadding="0" cellspacing="0" class="row-content stack" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; border-radius: 0; background-size: auto; color: #000000; background-color: #f6f5f1; width: 650px; margin: 0 auto;" width="650">
<tbody>
<tr>
<td class="column column-1" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="100%">
<table border="0" cellpadding="0" cellspacing="0" class="empty_block block-1" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
<tr>
<td class="pad">
<div></div>
</td>
</tr>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
<table align="center" border="0" cellpadding="0" cellspacing="0" class="row row-2" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-size: auto;" width="100%">
<tbody>
<tr>
<td>
<table align="center" border="0" cellpadding="0" cellspacing="0" class="row-content stack" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; border-radius: 0; background-size: auto; color: #000000; background-color: #d7e5f6; width: 650px; margin: 0 auto;" width="650">
<tbody>
<tr>
<td class="column column-1" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; padding-bottom: 50px; padding-left: 50px; padding-right: 50px; padding-top: 50px; vertical-align: bottom; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="100%">
<table border="0" cellpadding="0" cellspacing="0" class="icons_block block-1" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; text-align: center; line-height: 0;" width="100%">
<tr>
<td class="pad" style="vertical-align: middle; color: #000000; font-family: inherit; font-size: 14px; font-weight: 400; text-align: center;">
<table cellpadding="0" cellspacing="0" class="icons-outer" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; display: inline-table;">
<tr>
<td style="vertical-align: middle; text-align: center; padding-top: 5px; padding-bottom: 5px; padding-left: 5px; padding-right: 5px;"><img align="center" class="icon" height="auto" src="/media/svg/misc/Vectorcheck.svg" style="display: block; height: auto; margin: 0 auto; border: 0;" width="136"/></td>
</tr>
</table>
</td>
</tr>
</table>
<table border="0" cellpadding="0" cellspacing="0" class="paragraph_block block-2" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; word-break: break-word;" width="100%">
<tr>
<td class="pad">
<div style="color:#085cb9;font-family:'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:22px;font-weight:700;letter-spacing:0px;line-height:150%;text-align:center;mso-line-height-alt:33px;">
<p style="margin: 0; word-break: break-word;"><span style="word-break: break-word; color: #085cb9;">Pago realizado</span></p>
</div>
</td>
</tr>
</table>
<table border="0" cellpadding="0" cellspacing="0" class="paragraph_block block-3" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; word-break: break-word;" width="100%">
<tr>
<td class="pad">
<div style="color:#085cb9;font-family:'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:16px;font-weight:400;letter-spacing:0px;line-height:150%;text-align:center;mso-line-height-alt:24px;">
<p style="margin: 0; word-break: break-word;"><span style="word-break: break-word; color: #7b869d;">La transferencia del cliente ha sido procesada exitosamente</span></p>
</div>
</td>
</tr>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>

<table align="center" border="0" cellpadding="0" cellspacing="0" class="row row-6" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-size: auto;" width="100%">
<tbody>
<tr>
<td>
<table align="center" border="0" cellpadding="0" cellspacing="0" class="row-content stack" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; border-radius: 0; background-size: auto; color: #000000; background-color: #ffffff; border-left: 30px solid transparent; border-right: 30px solid transparent; border-top: 30px solid transparent; width: 650px; margin: 0 auto;" width="650">
<tbody>
<tr>
<td class="column column-1" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; background-color: #ffffff; padding-bottom: 30px; padding-top: 30px; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="100%">
<table border="0" cellpadding="20" cellspacing="0" class="heading_block block-1" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
<tr>
<td class="pad">
<h1 style="margin: 0; color: #222222; direction: ltr; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 20px; font-weight: 700; letter-spacing: normal; line-height: 120%; text-align: center; margin-top: 0; margin-bottom: 0; mso-line-height-alt: 24px;"><span class="tinyMce-placeholder" style="word-break: break-word; color: #7b869d;">Detalle del comprobante</span></h1>
</td>
</tr>
</table>
<table border="0" cellpadding="10" cellspacing="0" class="table_block mobile_hide block-2" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
<tr>
<td class="pad">
<table style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; border-collapse: collapse; width: 100%; table-layout: fixed; direction: ltr; background-color: #ffffff; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-weight: 400; color: #222222; text-align: left; letter-spacing: 0px; word-break: break-all;" width="100%">
<thead style="vertical-align: top; background-color: #eaeaea; color: #222222; font-size: 15px; line-height: 150%; text-align: left;">
<tr>
<th style="padding: 10px; word-break: break-word; font-weight: 700; border-top: 1px solid #eaeaea; border-right: 1px solid #eaeaea; border-bottom: 1px solid #eaeaea; border-left: 1px solid #eaeaea;" width="20%"><strong>Tipo</strong></th>
<th style="padding: 10px; word-break: break-word; font-weight: 700; border-top: 1px solid #eaeaea; border-right: 1px solid #eaeaea; border-bottom: 1px solid #eaeaea; border-left: 1px solid #eaeaea;" width="20%">Nº pago</th>
<th style="padding: 10px; word-break: break-word; font-weight: 700; border-top: 1px solid #eaeaea; border-right: 1px solid #eaeaea; border-bottom: 1px solid #eaeaea; border-left: 1px solid #eaeaea;" width="20%">Fecha de pago</th>
<th style="padding: 10px; word-break: break-word; font-weight: 700; border-top: 1px solid #eaeaea; border-right: 1px solid #eaeaea; border-bottom: 1px solid #eaeaea; border-left: 1px solid #eaeaea;" width="20%">Monto Pagado</th>
<th style="padding: 10px; word-break: break-word; font-weight: 700; border-top: 1px solid #eaeaea; border-right: 1px solid #eaeaea; border-bottom: 1px solid #eaeaea; border-left: 1px solid #eaeaea;" width="20%">Estado</th>
</tr>
</thead>
<tbody style="vertical-align: top; font-size: 14px; line-height: 150%;">
<tr style="background-color:#f9f9f9;" v-for="(itemDetalle,i) in order.detalles.filter(item => item!=null)" :key="'detail'+i">
<td style="padding: 10px; word-break: break-word; border-top: 1px solid #eaeaea; border-right: 1px solid #eaeaea; border-bottom: 1px solid #eaeaea; border-left: 1px solid #eaeaea;" width="20%">{{itemDetalle.tipoDocumento}}</td>
<td style="padding: 10px; word-break: break-word; border-top: 1px solid #eaeaea; border-right: 1px solid #eaeaea; border-bottom: 1px solid #eaeaea; border-left: 1px solid #eaeaea;" width="20%">{{itemDetalle.numeroDocumento}}</td>
<td style="padding: 10px; word-break: break-word; border-top: 1px solid #eaeaea; border-right: 1px solid #eaeaea; border-bottom: 1px solid #eaeaea; border-left: 1px solid #eaeaea;" width="20%">{{itemDetalle.fechaVencimiento | formatDate}}</td>
<td style="padding: 10px; word-break: break-word; border-top: 1px solid #eaeaea; border-right: 1px solid #eaeaea; border-bottom: 1px solid #eaeaea; border-left: 1px solid #eaeaea;" width="20%"><span v-if="itemDetalle.esRecibo">-{{itemDetalle.deuda | currency}}  </span><span v-else>{{itemDetalle.montoAsignado | currency}}</span></td>
<td style="padding: 10px; word-break: break-word; border-top: 1px solid #eaeaea; border-right: 1px solid #eaeaea; border-bottom: 1px solid #eaeaea; border-left: 1px solid #eaeaea;" width="20%"><span v-if="itemDetalle.pagoAceptadoBackend">ACEPTADO</span><span v-else>{{itemDetalle.Mensaje}}</span></td>
</tr>

</tbody>
</table>
</td>
</tr>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
<table align="center" border="0" cellpadding="0" cellspacing="0" class="row row-7" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-size: auto;" width="100%">
<tbody>
<tr>
<td>
<table align="center" border="0" cellpadding="0" cellspacing="0" class="row-content stack" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #ffffff; background-size: auto; border-radius: 0; color: #000000; width: 650px; margin: 0 auto;" width="650">
<tbody>
<tr>
<td class="column column-1" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="100%">
<table v-if="order.exitosoParcial" border="0" cellpadding="20" cellspacing="0" class="heading_block block-1" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
<tr>
<td class="pad">
<h1 style="margin: 0; color: #7b869d; direction: ltr; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 700; letter-spacing: normal; line-height: 120%; text-align: center; margin-top: 0; margin-bottom: 0; mso-line-height-alt: 19.2px;">Nos aseguraremos de que tu problema se solucione dentro de las próximas 24 horas. Gracias por tu paciencia.</h1>
</td>
</tr>
</table>

</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>

</td>
</tr>
</tbody>
</table>
                        <!--fin comprobante-->
                        <p>Puedes revisar el comprobante en <a href="/#payment/history">nuestro sitio web</a> o <a href="" v-on:click.prevent="getPdf()">descargarlo en formato PDF</a>.</p>
                      </div>
              </div>
            </div>
            <hr>
            <div v-show="send" class="alert alert-success">
              Se ha enviado correctamente el correo electrónico
            </div>
            
            <div class="row card card-row d-flex flex-row mb-4">
              
              <div class="col-2 text-center p-0">
                <img src="/media/img/email.svg" alt="">
              </div>
              <div class="col-10">
                <div class="d-flex flex-row justify-content-between align-items-center row">
                  <div class="form-group col-sm-12 col-lg-8 mb-1 mt-1">
                    <label for="">enviar una copia del comprobante a:</label>
                    <input type="email" v-model="order.email" placeholder="correo@empresa.cl" class="form-control">
                  </div>
                  <button type="submit" class="btn btn-outline-secondary px-5 mx-2" v-on:click.prevent="sendVoucher()">ENVIAR</button>
                
                </div>
              </div>
            </div>
             <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        color="green"
      ></v-progress-linear>
          

          <br>
          <div class="row mt-2 mb-5 row-buttons">
            <a class="btn btn-primary mr-3" href="#" v-on:click.prevent="getPdf()">descargar pdf</a>
            <a class="btn btn-outline-primary" href="/">volver al inicio</a>
          </div>

        </div>

 </template>
      </div>
     
    <!--end::Dashboard-->
</template>


<script>

import { mapState } from "vuex";
import { GET_ORDER, GET_PDF, SEND_PDF } from "@/core/services/store/payment.module";
//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
//import {Money} from 'v-money'

import moment from 'moment'
moment.locale( 'es' );

export default {
  name: "comprobante",
  components: {},
  data() {
    return {
      loading: false,
      order:{numeroTransaccion:0},
      email:null,
      send:false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$ ',
        suffix: '',
        precision: 0,
        masked: false
      }
    };
  },
  mounted () {
    console.log('params ' + this.$route.query.codigo);
    this.getOrder();
  },
  methods: {
    getOrder() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_ORDER, this.$route.query.codigo)
          .then((response)=>{this.order = response,this.$Progress.finish()});
    },
    sendVoucher() {
      const t = this;
      this.$Progress.start();
      this.$store
          .dispatch(SEND_PDF, {tokenOrden : this.order.tokenOrden, email : this.order.email})
          .then(function(){
            t.send = true;
            t.$Progress.finish()
          });
    },
    getPdf() {
      this.loading=true;
      const t = this;
      this.$Progress.start();
      this.$store
          .dispatch(GET_PDF, this.order.tokenOrden)
          .then(function(response){
            t.document = response;
            t.$Progress.finish()
            setTimeout(function()
              {
                console.log(t.document.data);
                var blob = new Blob([t.document], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.setAttribute('href', URL)
                link.href = url;
                
                link.setAttribute("download", "comprobante.pdf");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                t.loading=false;
              }, 0);
          });
    },
    
  },
  filters:{
    formatDate(value) {
        const duration = moment(value).format('DD/MM/yyyy');
        return `${duration}`;
    },

    formatTime(value) {
        const hora = moment(value).format('HH:mm:ss');
        return `${hora}`;
    }
  },
  computed: {
    ...mapState({
      details : state => state.payment.details,
      errors: state => state.errors,
      client: state => state.auth.user,
      rutCliente: function(){
        return `${this.order.rutEmpresa}-${this.order.dvEmpresa}`;
      },  
    })
  }
};
</script>
<style>
.b-form-datepicker {min-width:130px;}
.b-form-datepicker label {
        padding-bottom: 3px !important;
    padding-top: 6px;
    text-transform: none;
    white-space: nowrap !important;
    font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
    padding: 10px 5px;
}
.d-content-full{width:100%;}

.messaging {font-size: 0.8em;}
.alert-success {
    color: #155724 !important;
    background-color: #d4edda;
    border-color: #c3e6cb;
}
</style>
